// Pure preset-konfig for partikkel-emittere. Skilles ut fra Particles.ts
// så vi kan teste konfigurasjonen uten Phaser-init under Vitest.

export type PartikkelPreset = 'konfetti' | 'spark' | 'cha' | 'whoosh';

export type EmitterKonfig = {
  speed?: { min: number; max: number };
  speedX?: { min: number; max: number };
  speedY?: { min: number; max: number };
  angle?: { min: number; max: number };
  gravityY?: number;
  lifespan: { min: number; max: number };
  scale: { start: number; end: number };
  alpha: { start: number; end: number };
  rotate?: { min: number; max: number };
  tint: number[];
  quantity: number;
  frequency?: number;
  emitting: boolean;
};

const VINROD = 0x862736;
const OCHRE = 0xd9a14b;
const FOREST = 0x3d5a4d;
const GULL = 0xb8860b;
const YELLOW_WARM = 0xf4d58d;
const BEIGE = 0xf4ead5;
const HVIT = 0xffffff;

export function byggKonfetti(count = 30): EmitterKonfig {
  return {
    speed: { min: 380, max: 720 },
    angle: { min: 230, max: 310 },
    gravityY: 900,
    lifespan: { min: 1400, max: 2200 },
    scale: { start: 0.9, end: 0.4 },
    alpha: { start: 1, end: 0 },
    rotate: { min: 0, max: 360 },
    tint: [VINROD, OCHRE, FOREST, GULL],
    quantity: count,
    emitting: false,
  };
}

export function byggSpark(): EmitterKonfig {
  return {
    speed: { min: 160, max: 320 },
    angle: { min: 0, max: 360 },
    lifespan: { min: 400, max: 700 },
    scale: { start: 0.5, end: 0 },
    alpha: { start: 1, end: 0 },
    tint: [YELLOW_WARM, OCHRE, HVIT],
    quantity: 6,
    emitting: false,
  };
}

export function byggCha(): EmitterKonfig {
  return {
    speed: { min: 100, max: 260 },
    angle: { min: 250, max: 290 },
    gravityY: 1100,
    lifespan: { min: 1100, max: 1700 },
    scale: { start: 1.1, end: 0.7 },
    alpha: { start: 1, end: 0 },
    rotate: { min: -40, max: 40 },
    tint: [GULL, YELLOW_WARM, OCHRE],
    quantity: 12,
    emitting: false,
  };
}

export function byggWhoosh(retning: 1 | -1): EmitterKonfig {
  return {
    speedX: { min: 220 * retning, max: 460 * retning },
    speedY: { min: -40, max: 40 },
    lifespan: { min: 500, max: 900 },
    scale: { start: 0.7, end: 0 },
    alpha: { start: 0.85, end: 0 },
    tint: [HVIT, YELLOW_WARM, BEIGE],
    quantity: 4,
    frequency: 20,
    emitting: true,
  };
}

export function defaultCount(preset: PartikkelPreset): number {
  switch (preset) {
    case 'konfetti':
      return 30;
    case 'spark':
      return 6;
    case 'cha':
      return 12;
    case 'whoosh':
      return 4;
  }
}

export function whooshVarighet(fromX: number, toX: number): number {
  const lengde = Math.abs(toX - fromX);
  return Math.min(1200, Math.max(450, lengde));
}
